<template>
  <div class="file-storage">
    <main-app-bar>
      <template v-slot:title>
        Image & Video
      </template>
    </main-app-bar>

    <v-row class="mt-5 px-12 mb-10">
      <v-col cols="4">
        <v-text-field
          v-model.trim="params.search"
          hide-details
          rounded
          clearable
          dense
          filled
          single-line
          label="Public Id or File Name"
          :append-icon="icons.mdiMagnify"
          :loading="loading"
        />
      </v-col>
      <v-col cols="12">
        <ListTable
          :list="list"
          :meta="meta"
          :loading="loading"
          @loadMore="loadMore"
          @showDetails="showDetails"
        />
      </v-col>
    </v-row>
    <ResourcePreview
      v-if="!!currentRes"
      v-model="showPreview"
      :fileName="currentRes.original_file_name"
      :src="currentRes.file_url"
    />
  </div>
</template>
<script>
import MainAppBar from '@/layouts/shared/MainAppBar'
import ListTable from '../components/ListTable.vue'
import FS from '@/models/FS'
import ResourcePreview from '../components/ResourcePreview.vue'
import { mdiMagnify } from '@mdi/js'

const LIMIT = 50
export default {
  name: 'FileStorageIndex',
  components: {
    MainAppBar,
    ListTable,
    ResourcePreview,
  },
  data() {
    return {
      icons: {
        mdiMagnify,
      },
      params: {
        search: '',
      },
      page: 1,
      list: [],
      meta: {},
      loading: false,
      loadEnd: false,
      currentRes: null,
      showPreview: false,
      debounceTimer: null,
    }
  },
  watch: {
    'params.search'(newVal) {
      // Clear previous timer
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      // Set new timer to trigger search after user stops typing
      this.debounceTimer = setTimeout(() => {
        this.fetchList()
      }, 1000) // 500ms delay after user stops typing
    },
  },
  beforeDestroy() {
    // Clean up timer on component destroy
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  },
  methods: {
    async fetchList() {
      if (this.loading) return
      this.loading = true
      const res = await FS.page(1)
        .where('search', this.params.search)
        .params({ limit: LIMIT })
        .get()
      this.loading = false
      this.list = [...res.data]
      this.meta = res.meta
      this.loadEnd = LIMIT > res.data.length
    },
    async loadMore() {
      if (this.loading || this.loadEnd) return
      this.loading = true
      const res = await FS.page(this.page++)
        .where('search', this.params.search)
        .params({ limit: LIMIT })
        .get()
      this.loading = false
      this.list = [...this.list, ...res.data]
      this.meta = res.meta
      this.loadEnd = LIMIT > res.data.length
    },
    showDetails(row) {
      this.currentRes = row
      this.showPreview = true
    },
  },
}
</script>
<style scoped lang="scss"></style>
